import API from './API';

export default API;



// WEBPACK FOOTER //
// ./src/utils/api/index.js